/** Height of a tile column for terrain height h. */
export function columnHeight(h: number): number {
  return 0.25 + h * 0.32;
}

export const TILE_GAP = 0.06;
export const TILE_SIZE = 1 - TILE_GAP;
export const PLINTH_HEIGHT = 0.35;

/** World x/z of the centre of square (r, c). Basalt's back row (r = 0) is at negative z. */
export function squareCenter(r: number, c: number): [number, number] {
  return [c - 4, r - 4];
}

/** World position of the top face of square (r, c) at terrain height h. */
export function squareTop(r: number, c: number, h: number): [number, number, number] {
  const [x, z] = squareCenter(r, c);
  return [x, columnHeight(h), z];
}
